import { Injectable } from '@angular/core';
import { emobilityActions } from '@innogy/emobility-shared';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { Gender } from '@essent/common';
import { SubmitFormStepAction } from '@innogy/progressive-ngrx-forms';

import { CustomerType } from './lead-form-customer-details.reducer';
import { leadConsentsFormId } from './lead-form.consents.reducer';
import {
  selectChargePointConfigurationValue,
  selectCustomerDetailsValue,
  selectLeadFormAddressFormValue,
  selectLeadFormConsentsValue,
  selectLeadFormTrackingId,
} from './lead-form.selectors';
@Injectable()
export class LeadFormSmeSubmitEffects {
  leadFormCustomerDetails$ = this.store$.select(selectCustomerDetailsValue);
  leadFormAddress$ = this.store$.select(selectLeadFormAddressFormValue);
  leadFormConsents$ = this.store$.select(selectLeadFormConsentsValue);
  leadFormChargePointConfiguration$ = this.store$.select(
    selectChargePointConfigurationValue
  );
  e2eTrackingId$ = this.store$.select(selectLeadFormTrackingId);

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<any>
  ) {}

  public readonly submitLeadFormSme$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SubmitFormStepAction>(SubmitFormStepAction.TYPE),
      filter((action) => action.stepId === leadConsentsFormId),
      concatLatestFrom(() => [
        this.leadFormCustomerDetails$,
        this.leadFormAddress$,
        this.leadFormConsents$,
        this.leadFormChargePointConfiguration$,
        this.e2eTrackingId$,
      ]),
      filter(
        ([_, customerDetails]) =>
          customerDetails.customerType === CustomerType.SME
      ),
      map(
        ([
          _,
          customerDetails,
          address,
          consents,
          chargePointConfiguration,
          e2eTrackingId,
        ]) =>
          emobilityActions.postSmeLeadFormV1.requestAction({
            payload: {
              requestBody: {
                e2eTrackingId,
                chargeStationDetails: {
                  numberOfStations: chargePointConfiguration.numberOfStations,
                },
                personalDetails: {
                  gender: customerDetails.salutation ?? Gender.OTHER,
                  initials: customerDetails.initials,
                  prefix: customerDetails.prefix,
                  lastName: customerDetails.lastName,
                  phoneNumber: customerDetails.businessDetails.phoneNumber,
                  email: customerDetails.businessDetails.emailAddress,
                },
                organization: {
                  organizationName:
                    customerDetails.businessDetails.organizationName,
                  chamberOfCommerceNumber:
                    customerDetails.businessDetails.chamberOfCommerceNumber,
                },
                installationAddress: {
                  postalCode: address.installationAddressState.postalCode,
                  houseNumber:
                    address.installationAddressState.communicationNumber,
                  houseNumberAddition:
                    address.installationAddressState.houseNumberAddition,
                  street: address.installationAddressState.street,
                  city: address.installationAddressState.city,
                },
                consents: {
                  callback: consents.acceptedCallFromAdvisor,
                },
                correspondenceAddress: address.divergentCorrespondenceAddress
                  ? {
                      postalCode: address.correspondenceAddressState.postalCode,
                      houseNumber:
                        address.correspondenceAddressState.communicationNumber,
                      houseNumberAddition:
                        address.correspondenceAddressState.houseNumberAddition,
                      street: address.correspondenceAddressState.street,
                      city: address.correspondenceAddressState.city,
                    }
                  : undefined,
                remarks: `Terugbel moment: ${consents.callbackMoment}`,
              },
            },
          })
      )
    )
  );
}
